import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from './Context';
import Layout from './Layout';

const ProductsPage = (props) => (
  <Provider {...props}>
    <Layout />
  </Provider>
);

ProductsPage.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
// //   productCategories: jsonApiShape(productCategoryShape).isRequired,
// //   products: jsonApiShape(productShape).isRequired,
// //   productVariants: jsonApiShape(productVariantShape).isRequired,
};
//
// ProductsPage.defaultProps = {
// };

export default ProductsPage;
